export default "__VITE_ASSET__Dcx9ViHH__"